import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from '../../utils/axiosBaseQuery';

export const rolesApi = createApi({
    reducerPath: 'rolesApi',
    baseQuery: axiosBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`,
    }),
    endpoints: (build) => ({
        getRoles: build.query({
            query() {
                return {
                    url: `/admin/roles`,
                    method: 'GET'
                }
            },
            providesTags: ['Roles']
        }),
    }),
});

export const { useGetRolesQuery, useLazyGetRolesQuery } = rolesApi;